export const DEFAULT_REDIRECT_URI: string = '/check'
